import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { SiteCodes, WorkArea } from '../../entities/global/model';
import { SafetyConfigService } from '../../services/safety-config.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-edit-workarea-dialog',
  templateUrl: './edit-workarea-dialog.component.html',
  styleUrls: ['./edit-workarea-dialog.component.css']
})
export class EditWorkareaDialogComponent implements OnInit {

  constructor(
    public dialogRef:MatDialogRef<EditWorkareaDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _safetyConfigService:SafetyConfigService,
  ) { }

  selectedName:string="";
  selectedDescription:string="";
  workarealist:WorkArea[]=[];
  siteCodesList: SiteCodes[]=[];
  inputValuestate:number

  ngOnInit() {
    this.getworkarealist();
    this.loadSiteList();
  }

  state = new FormControl("", [Validators.required]);
  getErrorMessage() {
    return this.state.hasError("required") ? "You must enter a value" : "";
  }
  loadSiteList()
  {
    this._safetyConfigService.getAllSitesList().subscribe(sites =>
    { 
      console.log('sitelist',sites)
      this.siteCodesList=sites;
      
    });
  }
  DialogClose(){
    this.dialogRef.close(false)
  }

  EditWorkarea(){

    let model= new WorkArea()
    model.WorkAreaName=this.selectedName;
    model.WorkAreaDescription=this.selectedDescription

    model.Active=this.data.active
    model.ID=this.data.catId
    model.DepartmentID=this.data.DepartmentID
    model.SiteId=this.inputValuestate
    console.log('input values',model)
    this._safetyConfigService.UpdateWorkArea(model).subscribe(res =>{
 
  if(res.m_Item1=true){
    console.log('result', res)
    this.DialogClose();
   

  }});

  }

  getworkarealist(){
    this._safetyConfigService.GetDepartmentsAndWorkAreas().subscribe(res=>{ 
    this.workarealist=res.WorkAreas;

    this.workarealist.map(x=>{
      if(x.ID==this.data.catId)
      {
        this.selectedName=x.WorkAreaName
        this.selectedDescription=x.WorkAreaDescription 
        this.inputValuestate=x.SiteId
      }  
    })     
    })
  }

}

